import React, { useEffect, useState } from 'react';
import Layout from '@/components/Layout';
import PageHeader from '@/components/PageHeader';
import CtaBand from '@/components/CtaBand';
import { Star } from 'lucide-react';
import { api } from '@/lib/api';

export default function ReviewsPage() {
  const [reviews, setReviews] = useState([]);
  useEffect(() => { api.get('/reviews', { params: { limit: 48 } }).then(r => setReviews(r.data.reviews || [])); }, []);
  return (
    <Layout>
      <PageHeader eyebrow="Verified Reviews" title="Trusted by South Florida" subtitle="4.9 / 5 average across Google, Facebook, and BBB — thanks to a relentless focus on craft and communication." />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {reviews.map((r) => (
            <div key={r.id} data-testid={`review-card-${r.id}`} className="rounded-2xl border border-[#E6E9EE] bg-white p-5 shadow-[0_10px_30px_rgba(11,18,32,0.06)]">
              <div className="flex items-center gap-1 text-[#C8922F]">{Array.from({length:r.rating || 5}).map((_,i)=><Star key={i} className="h-4 w-4 fill-current"/>)}</div>
              <p className="mt-3 text-slate-700">{r.text}</p>
              <div className="mt-4 text-sm text-slate-500">— {r.author}, {r.city}</div>
              {r.service && <div className="text-xs text-slate-400 mt-1">{r.service}</div>}
            </div>
          ))}
        </div>
      </section>
      <CtaBand />
    </Layout>
  );
}
